<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <div class="m-portlet__head">
        <div class="m-portlet__head-progress">
          <!-- here can place a progress bar-->
        </div>
        <div class="m-portlet__head-wrapper">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">带教老师信息 | 评分详细</h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <el-button @click="Back()">返回</el-button>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <form class="m-form m-form--label-align-left- m-form--state-" id="m_form">
          <!--begin: Form Body -->
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-xl-9 offset-xl-1">
                <div class="m-form__section m-form__section--first">
                  <div class="form-group m-form__group row">
                    <label class="col-xl-2 col-lg-2 col-form-label" style="text-align: right;">带教老师姓名：</label>
                    <div class="col-xl-10 col-lg-10">
                      <div class="input-group" style="padding-top: 8px;">
                        <span>{{this.truename}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <label class="col-xl-2 col-lg-2 col-form-label" style="text-align: right;">科室：</label>
                    <div class="col-xl-4 col-lg-4">
                      <div class="input-group" style="padding-top: 8px;">
                        <span>{{this.sectionname}}</span>
                      </div>
                    </div>
                    <label class="col-xl-2 col-lg-2 col-form-label" style="text-align: right;">考核月份：</label>
                    <div class="col-xl-4 col-lg-4">
                      <div class="input-group" style="padding-top: 8px;">
                        <span>{{this.cpidate}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group m-form__group row">
                    <label class="col-xl-2 col-lg-2 col-form-label" style="text-align: right;">评分表内容：</label>
                    <div class="col-xl-10 col-lg-10" v-html="tableData">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreTeachScoreRecord',
  data () {
    return {
      condition: {
        cpitype: '2',
        token: '',
        id: ''
      },
      tableData: null,
      userid: '',
      truename: '',
      cpidate: '',
      sectionname: ''
    }
  },
  filters: {
    formatDate (val) {
      var now = new Date(val)
      var y = now.getFullYear()
      var m = now.getMonth() + 1
      return y + '-' + (m < 10 ? '0' + m : m)
    }
  },
  methods: {
    Back: function () {
      this.$router.push({name: 'TeachScoreList', params: {tecid: this.userid, tecname: this.truename, secname: this.sectionname}})
    },
    LoadCPIDetail: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ReportCPIDetail', this.condition)
        .then(res => {
          if (res.data.Code === 0) {
            this.tableData = res.data.Data
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          this.tabScore = ''
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    },
    LoadCPIInfo: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ReportCPIInfo', this.condition)
        .then(res => {
          if (res.data.Code === 0) {
            this.userid = res.data.Data.TecID
            this.truename = res.data.Data.TrueName
            this.sectionname = res.data.Data.SectionName
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.condition.id = this.$route.params.id
    this.cpidate = this.$route.params.month
    this.LoadCPIDetail()
    this.LoadCPIInfo()
  }
}
</script>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>
